import { InfoCircleOutlined, StarTwoTone, ClockCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import { Button, Modal } from "antd";
import React, { useState } from "react";
import { $t } from "~/i18n.js";
import { colors } from "~/theme/colors.js";
import { ScoreForm } from "./ScoreForm.jsx";

import { _parseDate } from "~/lib/localize.js";

import { SluitButton } from "~/components/buttons/SluitButton.jsx";
import { BevoegdheidExpirationWarning } from "./BevoegdheidExpirationWarning.jsx";
import { BevoegdheidHistory } from "./BevoegdheidHistory.jsx";
import { BevoegdheidScore } from "./BevoegdheidScore.jsx";
import { Tag } from "antd";
import { DateFormat } from "~/components/date/DateFormat.jsx";

export const Bevoegdheid = ({
  user_id,
  cluster,
  bevoegdheid,
  setBevoegdheid,
  openBevoegheid,
  latestAchievement,
}) => {
  const [loading, setLoading] = useState(false);
  const [showScoreBevoegdheid, setScoreShowModal] = useState(null);

  const [remark, setRemark] = useState("");
  const [newScore, setScore] = useState(null);

  // Check if this bevoegdheid is the latest achievement
  const isLatestAchievedBevoegdheid = latestAchievement && 
    latestAchievement.bevoegdheid && 
    latestAchievement.bevoegdheid.id === bevoegdheid.id;
  const [date_assigned, setDateAssigned] = useState(dayjs());
  const [date_geldig, setDateGeldig] = useState(null);

  const triggerSetBevoegdheid = async (id, _score) => {
    setLoading(true);
    await setBevoegdheid({
      id,
      user_id,
      score: _score,
      remark: remark ? remark.substring(0, 90) : "",
      is_dto: cluster.is_dto,
      date_assigned: date_assigned.format("YYYY-MM-DD"),
      date_geldig: date_geldig ? date_geldig.format("YYYY-MM-DD") : null,
    });
    setRemark("");
    setScore(null);
    setDateGeldig(null);
    setScoreShowModal(null);
    setLoading(false);
  };

  const score = bevoegdheid.behaald.score || 0;
  return (
    <div className="row bevoegdheid"  style={{ alignItems: "flex-start" }}>
      {showScoreBevoegdheid && (
        <Modal
          title={bevoegdheid.label || bevoegdheid.name}
          open={showScoreBevoegdheid !== null}
          onCancel={() => setScoreShowModal(false)}
          footer={[
            <SluitButton
              key="sluit"
              onClick={() => setScoreShowModal(false)}
            />,
            <Button
              key="opslaan"
              type="primary"
              loading={loading}
              onClick={() => {
                // check remark or scoring
                triggerSetBevoegdheid(showScoreBevoegdheid.id, newScore);
              }}
            >
              {$t("toekennen")}
            </Button>,
          ]}
        >
          <ScoreForm
            bevoegdheid={showScoreBevoegdheid}
            setScore={setScore}
            setRemark={setRemark}
            score={newScore}
            remark={remark}
            date_assigned={date_assigned}
            setDateAssigned={setDateAssigned}
            date_geldig={date_geldig}
            setDateGeldig={setDateGeldig}
          />

          <BevoegdheidHistory
            behaalde_bevoegdheid_id={bevoegdheid.behaald?.id}
            currentBevoegdheid={bevoegdheid.behaald}
          />
        </Modal>
      )}

      <div className="row" style={{ alignItems: "flex-start" }}>
        <BevoegdheidScore score={score} />

        {bevoegdheid.endorse_title && (
          <StarTwoTone
            twoToneColor={colors.primary}
            style={{ marginLeft: 6 }}
          />
        )}

        <p
          className="clickable"
          onClick={() => openBevoegheid(bevoegdheid)}
          style={{ marginLeft: 6 }}
        >
          {bevoegdheid.label || bevoegdheid.name}{" "}
          {isLatestAchievedBevoegdheid && (
            <Tag icon={<ClockCircleOutlined />} color="green">
            </Tag>
          )}
          {bevoegdheid.behaald.date_geldig && (
            <Tag>
              <DateFormat date={bevoegdheid.behaald.date_geldig} />
            </Tag>
          )}
          <BevoegdheidExpirationWarning bevoegdheid={bevoegdheid} />
          
        </p>
      </div>

      <div>
        {bevoegdheid.behaald.date_behaald && bevoegdheid.behaald.valid && (
          <span className="small gray">
            {_parseDate(bevoegdheid.behaald.date_behaald)}
          </span>
        )}

        {setBevoegdheid && !bevoegdheid.behaald.assigned && (
          <Button
            onClick={() => {

              // direct scoring only for boolean without remark
              if (
                bevoegdheid.scoring === "boolean" &&
                !bevoegdheid.has_remark &&
                !bevoegdheid.geldigheid
              ) {
                return triggerSetBevoegdheid(bevoegdheid.id, "assigned");
              }
              if (bevoegdheid.geldigheid > 0) {
                setDateGeldig(dayjs().add(bevoegdheid.geldigheid, "day"));
              } else if (bevoegdheid.valid_doy > 0) {
                const now = dayjs();
                const year = now.year();
                const doyDate = dayjs(`${year}-01-01`).add(bevoegdheid.valid_doy - 1, 'day');
                // If the calculated date has already passed this year, set to next year
                if (doyDate.isBefore(now, 'day')) {
                  setDateGeldig(doyDate.add(1, 'year'));
                } else {
                  setDateGeldig(doyDate);
                }
              }

              if (bevoegdheid.scoring === "boolean") {
                setScore("assigned");
              } else {
                setScore(score);
              }
              return setScoreShowModal(bevoegdheid);
            }}
            type="link"
            loading={loading}
            size="small"
          >
            {$t("toekennen")}
          </Button>
        )}

        {setBevoegdheid && bevoegdheid.behaald.assigned && (
          <Button
            ghost
            shape="circle"
            className="openButton"
            onClick={() => openBevoegheid(bevoegdheid)}
            icon={
              <InfoCircleOutlined
                className="clickable"
                style={{ color: colors.primary_light, fontSize: 16 }}
              />
            }
            size="small"
          />
        )}
      </div>
    </div>
  );
};
